import { getData, sendData, sendForBlobData } from './apiService';
import NotificationManager from 'react-notifications/lib/NotificationManager';

export async function getAll(query, value) {
  try {
    let response = await sendData(
      `deposit-invoice/search?total=true&${new URLSearchParams(query).toString()}`,
      value,
      'POST',
      false
    );
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}



export async function save(values) {
  try {
   
   return await sendData('deposit-invoice/create', values);
  } catch (e) {
    NotificationManager.error(e.response.data.message);
    return false;
  }
}



export async function deleteData(_id) {
  try {
    let response = await sendData('deposit-invoice/delete', { id: _id });
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function deleteAllData(data) {
  try {
    let response = await sendData('deposit-invoice', data, 'DELETE');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function update(values) {
  try {
    return await sendData('deposit-invoice/update/' + values._id, values, 'PUT');
  } catch (e) {
    NotificationManager.error(e.response.data.error);
    return false;
  }
}

export async function fetchInvoiceNumber() {
  try {
    let response = await getData('deposit-invoice/request-invoice-number');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function deleteImage(file, invoiceNumber, type) {
  try {
    return await sendData(
      `deposit-invoice-files/invoice-image-delete-custom?file_name=${file}&invoice_id=${invoiceNumber}&type=${type}`,
      {},
      'DELETE'
    );
  } catch (e) {
    NotificationManager.error(e.response.data.error);
    return false;
  }
}

export async function exportData(data) {
  return await sendForBlobData('deposit-invoice/export-deposit-invoice', data, {
    responseType: 'blob',
  });
}

export async function exportDataItems(data) {
  return await sendForBlobData('deposit-invoice/export-deposit-invoice-items', data, {
    responseType: 'blob',
  });
}

export async function getDepositInvoiceByNumber(query) {
  try {
    let response = await getData(`deposit-invoice/get-invoice?${new URLSearchParams(query).toString()}`);
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function updateDepositInvoice(data) {
  try {
    let response = await sendData('deposit-invoice/update-invoice', data, 'PATCH');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}
